import { unitId } from '@/annotations'
import { AuthCard } from '@/components/AuthCard'
import { AuthCardBrand } from '@/components/AuthCardBrand'
import { AuthCardLead } from '@/components/AuthCardLead'
import { Strip } from '@/components/Strip'
import { AUTH_BRAND, A_VERIFY_COPY } from '@/copy/registry'

/**
 * `a-verify` — family rule A4: outside the shell and outside authentication entirely; the
 * single-use hashed link value IS the authorisation (§3.1i rule 4, `VerificationResult.yaml`).
 * `display` is server-formatted — this component renders it, never composes its own sentence
 * from `email` (§24.2 rule 24). Purely presentational — `AddressVerificationEntry` calls
 * `identityConfirmAddressVerification` and renders this on `VERIFIED`.
 */
export function AVerify({ display }: { display?: string }) {
  return (
    <AuthCard unitId={unitId('a-verify')}>
      <AuthCardBrand label={AUTH_BRAND} />
      <h3 className="m-0 mb-3 text-section font-semibold">{A_VERIFY_COPY.heading}</h3>
      <AuthCardLead>{display ?? A_VERIFY_COPY.fallbackLead}</AuthCardLead>
      <div className="my-14">
        <Strip>{A_VERIFY_COPY.scopeStrip}</Strip>
      </div>
    </AuthCard>
  )
}
